import { CheckCircleIcon, CloseCircleIcon } from "../assets/icons"
import PropTypes from "prop-types"
import { toast } from "react-toastify"
import clsx from "clsx"
import React from "react"

const showToasts = (type = "regular", message) => {
  const toastContent = () => (
    <div
      className={clsx(
        (type === "success" || type === "error" || type === "regular") &&
          "text-white",
        (type === "success" || type === "error") && "flex"
      )}
    >
      {type === "success" && <CheckCircleIcon className="white-svg h-6 w-6" />}
      {type === "error" && <CloseCircleIcon className="white-svg h-6 w-6" />}
      {type !== "notification" && message}
      {type === "notification" && (
        <div>
          <p>{message?.title}</p>
          <p>{message?.body}</p>
        </div>
      )}
    </div>
  )

  toast.dismiss()
  toast(toastContent(), {
    className: `toast-content toast-${type}`,
  })
}

showToasts.propTypes = {
  type: PropTypes.oneOf(["regular", "success", "error"]).isRequired,
  message: PropTypes.string.isRequired,
}

export default showToasts
